"use client";

import dynamic from "next/dynamic";
import { useLocale } from "next-intl";
import type { ReactNode } from "react";

// KAN-975: словарь раздела турниров — свой чанк на локаль, как у админки и корня. Остальным страницам
// эти переводы не едут. next/dynamic при SSR сам ставит preload чанка отрисованной локали; при
// клиентском переходе чанк подгружается заранее по наведению на ссылку меню (см. ../preload).
const TournamentsMessagesRu = dynamic(() => import("./tournaments-messages-ru").then((m) => m.TournamentsMessagesRu));
const TournamentsMessagesEn = dynamic(() => import("./tournaments-messages-en").then((m) => m.TournamentsMessagesEn));

export function TournamentsMessages({ children }: { children: ReactNode }) {
  return useLocale() === "en" ? (
    <TournamentsMessagesEn>{children}</TournamentsMessagesEn>
  ) : (
    <TournamentsMessagesRu>{children}</TournamentsMessagesRu>
  );
}
